const formFields = {
  TELEGRAM_TOKEN: "telegram_token"
};

// логика работы инпута с токеном телеграма:
// чтобы сбросить токен, надо отправить telegram_token: null
// чтобы оставить таким, какой есть сейчас на сервере, надо отправить telegram_token: undefined
// пустую строку в это поле положить нельзя, т.к. сервер будет жаловаться
// также пустые строки нельзя ложить во все остальные поля, так что мы заменяем пустые строки на null

export const assignNullValueForEmptyValues = (dataObject) => {
  return Object.entries(dataObject)
    .reduce((acc, keyValueArr) => {
      if (keyValueArr[0] === formFields.TELEGRAM_TOKEN) {
        acc[keyValueArr[0]] = keyValueArr[1] || undefined;
      } else if (keyValueArr[1] || keyValueArr[1] === false) {
        acc[keyValueArr[0]] = keyValueArr[1];
      } else {
        acc[keyValueArr[0]] = null;
      }
      return acc;
    }, {});
};

export const settingsDataFields = ["telegram_connect_key", "telegram_token", "is_telegram_auth_enabled", "nexmo_app_id", "nexmo_from_phone", "nexmo_private_key", "jira_token", "jira_url"];
